<cs-header>
  <cs-header-title>
    {{ title }}
    <cs-header-title-action>
      <cs-button secondary x-small class="today-button" (click)="onToday()"
        [label]="LL.common.buttons.today()">
      </cs-button>
    </cs-header-title-action>
  </cs-header-title>
  @if (description) {
    <div class="description">
      {{ description }}
    </div>
  }
</cs-header>

<cs-content class="scroll-viewport" [loading]="loading">
  <!-- Loading indicator at the top -->
  @if (canLoadEarlier && !loading) {
    <div class="loading-sentinel top" #topSentinel>
      <div class="loading-indicator">{{ LL.app.loading() }}</div>
    </div>
  }

  @for (month of months; track trackByMonthId($index, month)) {
    <div class="month" [attr.data-month-id]="month.monthId">
      <!-- Month/Year label -->
      <div class="month-label">
        <span class="month-name">{{ month.monthName }}</span>
        @if (month.year) {
          <span class="year">{{ month.year }}</span>
        }
      </div>
      <!-- Month calendar grid -->
      <div class="month-grid">
        @for (week of month.weeks; track week) {
          <div class="week">
            @for (day of week.days; track day) {
              <cs-task-calendar-day [date]="day.date" [taskStatus]="day.taskStatus"
                [attr.data-date]="day.dateKey"
                [isSelected]="day.isSelected" [isToday]="day.isToday" [showDayOfWeek]="true" [showStatus]="true"
              [class.out-of-month]="day.isOutOfMonth" (dateClick)="onDateClick($event)"></cs-task-calendar-day>
            }
          </div>
        }
      </div>
    </div>
  }

  <!-- Loading indicator at the bottom -->
  @if (canLoadLater && !loading) {
    <div class="loading-sentinel bottom" #bottomSentinel>
      <div class="loading-indicator">{{ LL.app.loading() }}</div>
    </div>
  }
</cs-content>
